// temporary way until someone makes a UI like with themes
// though the console api might still be useful
// and we may want a language list etc
type LanguageChangedCallback = (newLang: string) => void;

type Unsubscribe = () => void;

interface LanguageManager {
  getLang: () => string;
  setLang: (newLang: string) => void;
  subscribe: (subscriber: LanguageChangedCallback) => Unsubscribe;
}

declare global {
  interface Window {
    interact: LanguageManager;
  }
}

export const createLanguageManager = () => {
  let subscribers: LanguageChangedCallback[] = [];

  const searchParams = new URLSearchParams(document.location.search.substring(1));
  let lang = searchParams.get("lang") || "en";

  const notifySubscribers = (newLang: string) => {
    for (const subscriber of subscribers) {
      subscriber(newLang);
    }
  };

  const manager: LanguageManager = {
    getLang: () => lang,
    setLang: (newLang) => {
      lang = newLang;
      searchParams.set("lang", newLang);
      window.history.replaceState({}, `lang: ${newLang}`, `?${searchParams.toString()}`);
      notifySubscribers(newLang);
    },
    subscribe: (subscriber) => {
      subscribers.push(subscriber);
      return () => {
        return (subscribers = subscribers.filter((s) => s !== subscriber));
      };
    },
  };
  return manager;
};
